<template>
    <v-container  class="align-start mt-3">
        <v-row align="center"> 
                <v-col style="max-width: 180px" cols="12" md="6">
                    <v-select
                        style="max-width: 150px"
                        :items="seasons"
                        v-model="currentSeason"
                        label="Season"
                        :hint="selectedYear"
                        persistent-hint
                        class="pa-3 pr-0"
                        dense
                        @change="refreshHeaders()"
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" md="7">
                    <v-row class="ml-3">
                        <v-switch                            
                            v-model="simple"
                            label="Simple"
                        ></v-switch>
                        <v-switch                            
                            v-model="active"
                            label="Active players"
                        ></v-switch>
                    </v-row>
                </v-col>
        </v-row>
        <v-col md="12" align="top">
            <v-data-table            
                :headers="headers"
                :loading="loading"                
                :items="showPlayers"
                :items-per-page="25"
                :search="search"
                :custom-filter="filterName"
                :footer-props="footerProps"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :custom-sort="customSort"      
                :options.sync="options"          
                fluid
                class="elevation-1"
                :mobile-breakpoint="mobile" 
                @click:row="handleClick"
            >
                <template v-slot:top>
                    <v-text-field
                    v-model="search"
                    label="Search player"
                    class="mx-4"
                    ></v-text-field>
                </template>       
                <template v-slot:header.rank.name="{ header }">
                    <v-row justify="left" align="center">
                        <v-col style="max-width: 40px">{{ header.text }}</v-col>
                        <v-col style="max-width: 20px" >
                             <v-btn
                                icon
                                color="pink"
                                x-small
                                @click="rankHelp"
                                >
                                <v-icon>mdi-help-circle-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>         
                <template                
                    v-slot:item.rank.name="{ item }"
                >
                    <div class="d-flex justify-center" v-if="item.rank" @click.stop.prevent="">                    
                        <v-tooltip right>  
                            <template v-slot:activator="{ on, attrs }">
                                <img                                
                                    width="70"
                                    v-bind="attrs"
                                    v-on="on"
                                    :src="getImageString(item.rank.numerical_value)"/>                                        
                            </template>
                            <span>{{item.rank.name}}</span>
                        </v-tooltip>
                    </div>
            </template>
            </v-data-table>
        </v-col>
        <rank-dialog :dialog="showHelp" :rankDistribution="rankDistribution" :limits="rankLimits" @closeHelp="showHelp = false"></rank-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { get, cloneDeep } from 'lodash'
import { mean, standardDeviation, zScore } from 'simple-statistics'
import RankDialog from '../components/RankDialog'
import Ranks from "../ranks"
    export default {
        name: "Players",
        mixins:  [Ranks],
        components: {
            RankDialog                
        },
        data() {
            return {
                search: "",
                currentSeason: "All",
                seasons: ["All"],
                statName: ["score", "season_best", "season_worst", "games", "wins", "loses", "winPercent", "rounds", "roundsWon", "roundsLost", 
                        "roundsPercent", "twoZero", "twoZeroPercentWins", "twoZeroPercentAll", "twoOne", 
                        "twoOnePercentWins", "twoOnePercentAll", "zeroTwo", "zeroTwoPercentWins", "zeroTwoPercentAll", 
                        "oneTwo", "oneTwoPercentWins", "oneTwoPercentAll", "winOnTwoRoundsPercent", "winOnThreeRoundsPercent"],
                shortStats: [
                    "score", "season_best", "games"
                ],
                fullHeaders: [
                    {
                        text: 'Rank',
                        align: 'start',
                        width:'80px',
                        sortable: false,
                        value: 'rank.name',
                    },
                    { text: 'Name', value: 'name' },
                    { text: 'Score', value: 'score' },
                    { text: 'Season best', value: 'season_best' },
                    { text: 'Season worst', value: 'season_worst' },
                    { text: 'Games played', value: 'games', width:'70px'},
                    { text: 'Games won', value: 'wins', width:'70px'},
                    { text: 'Games lost', value: 'loses', width:'70px'},
                    { text: 'Win %', value: 'winPercent', width:'70px'},
                    { text: 'Rounds', value: 'round', width:'70px'},
                    { text: 'Rounds won', value: 'roundsWon', width:'70px'},
                    { text: 'Rounds lost', value: 'roundsLost', width:'70px'},
                    { text: 'Round win%', value: 'roundsPercent', width:'70px'},
                    { text: '2-0 won', value: 'twoZero', width:'70px'},
                    { text: '2-0 % of wins', value: 'twoZeroPercentWins', width:'70px'},
                    { text: '2-0 % of all', value: 'twoZeroPercentAll', width:'70px'},
                    { text: '2-1 won', value: 'twoOne', width:'70px'},
                    { text: '2-1 % of wins', value: 'twoOnePercentWins', width:'70px'},
                    { text: '2-1 % of all', value: 'twoOnePercentAll', width:'70px'},
                    { text: '0-2 loss', value: 'zeroTwo', width:'70px'},
                    { text: '0-2 % of loses', value: 'zeroTwoPercentWins', width:'70px'},
                    { text: '0-2 % of all', value: 'zeroTwoPercentAll', width:'70px'},
                    { text: '1-2 loss', value: 'oneTwo', width:'70px'},
                    { text: '1-2 % of loses', value: 'oneTwoPercentWins', width:'70px'},
                    { text: '1-2 % of all', value: 'oneTwoPercentAll', width:'70px'},
                    { text: '2-0 win% 2 round games', value: 'winOnTwoRoundsPercent', width:'70px'},
                    { text: '2-1 win% 3 round games', value: 'winOnThreeRoundsPercent', width:'70px' }                
                ],
                shortHeaders: [
                    {
                        text: 'Rank',
                        align: 'start',
                        width:'80px',
                        sortable: false,
                        value: 'rank.name',
                    },
                    { text: 'Name', value: 'name' },
                    { text: 'Score', value: 'score' },
                    { text: 'Season best', value: 'season_best' },
                    { text: 'Games played', value: 'games', width:'70px'},
                ],
                headers: [],
                footerProps: {'items-per-page-options': [25, 50, 75, 100, -1]},
                simple: false,
                active: false,
                mobile: 600,
                sortBy: null,
                sortDesc: null,
                showPlayers: [],
                options: {},
                rankedPlayers: [],
                zScores: [],
                rankDistribution: {},
                rankLimits: [],
                showHelp: false
            }
        },
        methods: {
            filterName (value, search, item) {
                if(!search) return true
                else return item.name.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
            },
            refreshHeaders(){                
                for(let i = 2; i < this.fullHeaders.length; i++){
                    this.fullHeaders[i].value = this.selectedSeason ? 
                        "seasons[" + this.selectedSeason + "]." + this.statName[i - 2] : this.statName[i - 2]
                }
                for(let i = 2; i < this.shortHeaders.length; i++){
                    this.shortHeaders[i].value = this.selectedSeason ? 
                        "seasons[" + this.selectedSeason + "]." + this.shortStats[i - 2] : this.shortStats[i - 2]
                }
                if(this.currentSeason == "All" || this.currentSeason == this.seasons[this.seasons.length - 1]) {
                    this.sortBy = null
                    this.sortDesc = null
                }
                else {
                    let header = this.headers.find(h => h.text === "Score")
                    this.sortBy = header.value
                    this.sortDesc = false
                }
                this.filterActive()
                localStorage.currentSeason = this.currentSeason
            },
            customSort(items, index, isDesc) {                
                if(index.length > 0){
                    items.sort((a, b) => {
                        if (isDesc[0] != false) {                                   
                            return get(a, index[0]) < get(b, index[0]) ? -1 : 1
                        } else {                        
                            return get(b, index[0]) < get(a, index[0]) ? -1 : 1
                        }
                    })
                }
                return items
            },
            getImageString(image){ 
                return this.ranks.find(item => item.numerical_value == image).image_url
            },
            handleClick(item){                
                this.$router.push({ name: 'Player', params: { id: item.id } })
            },
            filterActive(){
                if(this.active){
                    let value = this.headers.find(h => h.text === "Games played").value
                    this.showPlayers = cloneDeep(this.sortedPlayers).filter(item => get(item, value) != 0)
                } else {
                    this.showPlayers = cloneDeep(this.sortedPlayers)
                }
            },
            calculateZScore(values){    
                let playerMean = mean(values)
                let std = standardDeviation(values)
                this.zScores = values.map(item => zScore(item, playerMean, std))
            },
            calculateRankLimits(values){    
                let limits = Object.keys(this.rankDistribution).map(item => +item).sort((a,b) => b-a)
                let playerMean = mean(values)
                let std = standardDeviation(values)
                for(let limit of limits){
                    let rank = this.rankDistribution[limit]
                    rank.limit = limit * std  + playerMean                    
                }
            },
            findRankedPlayers(){
                let newest = this.seasons[this.seasons.length - 1]                
                this.rankedPlayers = this.sortedPlayers.filter(item => {
                    return item.seasons[newest].roundsWon >= 5
                })
                if(this.rankedPlayers.length == 1){
                    this.zScores = []
                    this.zScores.length = this.rankedPlayers.length
                    this.zScores.fill(0)
                }else {                    
                    let scores = this.rankedPlayers.map(item => item.score)
                    if(scores.length > 0){
                        this.calculateZScore(scores)
                        this.rankLimits = Object.keys(this.rankDistribution).map(item => +item).sort((a,b) => b-a)
                        //Just to verify if ranks are same to backend
                        // for(let [index, player] of this.rankedPlayers.entries()){
                        //     let playerZ = this.zScores[index]                        
                        //     let filtered = limits.filter(item => item <= playerZ)
                        //     player.calculatedRank = this.rankDistribution[filtered[0]]
                        // }                                        
                        this.calculateRankLimits(scores)
                    }
                }
            },
            rankHelp(){                
                this.showHelp = !this.showHelp
            }
        },
        watch: {
            gameStats: {
                deep: true,
                handler(){
                    this.seasons = ["All", ...Object.keys(this.gameStats.seasons)]
                    this.currentSeason = this.seasons[this.seasons.length - 1]
                    this.refreshHeaders()
                    this.findRankedPlayers()
                }
            },
            simple(){                
                if(this.simple){
                    this.headers = this.shortHeaders
                    this.mobile = 0
                } else {
                    this.headers = this.fullHeaders
                    this.mobile = 600
                }
                localStorage.simple = this.simple
            },
            active(){
                this.filterActive()
                localStorage.active = this.active
            },
            loading(){
                if(this.loading == false) {
                    this.showPlayers = cloneDeep(this.sortedPlayers)
                    this.findRankedPlayers()
                }
            },
            options: {
                handler () {                    
                    localStorage.pageOptions = Buffer.from(JSON.stringify(this.options)).toString("base64");                
                },
                deep: true,
            },
            search(){
                localStorage.searchPlayer = this.search
            }
        },
        computed: {
            ...mapGetters(['sortedPlayers', 'gameStats']),
            selectedSeason(){   
                if(this.currentSeason == "All"){
                    return 0
                } else {
                    return +this.currentSeason
                }
            },
            selectedYear(){
                if(this.currentSeason != "All"){
                    return (2015 + +this.currentSeason).toString()
                }else {
                    return ""
                }
            },
            loading(){
                if(this.sortedPlayers.length == 0) return true
                else return false
            }
        },
        mounted(){
            let step = 6 / (this.ranks.length - 2)            
            for (let i = 0; i < (this.ranks.length - 2); i++){
                this.rankDistribution[-3 + i * step] = this.ranks[i]
            }

            this.seasons = Object.keys(this.gameStats.seasons) != 0 ? ["All", ...Object.keys(this.gameStats.seasons)]: ["All"]
            this.currentSeason = this.seasons[this.seasons.length - 1]
            this.headers = this.fullHeaders
            this.showPlayers = cloneDeep(this.sortedPlayers)            
            if(this.sortedPlayers.length > 0) this.findRankedPlayers();
            if(localStorage.simple != null) {                
                this.simple = String(localStorage.simple).toLowerCase() == "true" ? true : false
            }
            if(localStorage.active != null) {                
                this.active = String(localStorage.active).toLowerCase() == "true" ? true : false
            }
            if(localStorage.currentSeason != null) {                            
                this.currentSeason = localStorage.currentSeason
            }
            if(localStorage.searchPlayer != null) {                
                this.search = localStorage.searchPlayer
            }
            if(localStorage.pageOptions != null) {                                
                this.options = JSON.parse(Buffer(localStorage.pageOptions, 'base64').toString())
            }
            this.refreshHeaders()
        }
    }
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header th {
  white-space: nowrap;
}
</style>